// extracted by mini-css-extract-plugin
export default {"wrapper":"SuperOrderTransactionsModal_wrapper__yMYNA","modal":"SuperOrderTransactionsModal_modal__eKu4Y"};